import { render, staticRenderFns } from "./NewLanding__4.vue?vue&type=template&id=6100276b&scoped=true&"
import script from "./NewLanding__4.vue?vue&type=script&lang=js&"
export * from "./NewLanding__4.vue?vue&type=script&lang=js&"
import style0 from "./NewLanding__4.vue?vue&type=style&index=0&id=6100276b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100276b",
  null
  
)

export default component.exports